
export const checkParams = (obj) => {
  console.log(obj)
  for (var key in obj) {
    if (obj[key] === "")
      return false;
  }
  return true;
}